module.exports = __webpack_public_path__ + "img/Vector 4.b34d8448.svg";